import {FC} from "react";
import {WidthWrapper} from "../../../../../../app/widthWrapper";
import {CaseHeader} from "../../../../../../shared/components/caseHeader";
import {FlexColumn} from "../../../../../../shared/components/box";

import IPhones from "../../files/hobbily-header.png"
import {animationOnScroll} from "../../../../../../shared/animationOnScroll";

export const HobbilyHeader: FC = () => {


    return (
        <WidthWrapper caseWrapper>
            <FlexColumn sx={({breakpoints}) => ({
                width: '100%',

                mt: '9.4rem',
                gap: '8.0rem',
                [breakpoints.down(376)]: {
                    gap: '6.6rem',
                    mt: '5.4rem',
                },
            })}>
                <CaseHeader title={"Hobbily - mobile app for hobby events"}
                            description={'Explore your hobbies, find hobby events nearby and connect with other users who share the same interests.'}
                            footer={['2022', 'UX/UI designer', 'Research, Competitor analysis, Wireframing, Prototyping, Visual Design']}
                />

                <img {...animationOnScroll({type: 'fade-up'})} src={IPhones} alt={'IPhones'} style={{width: '100%', height: 'auto'}}/>
            </FlexColumn>
        </WidthWrapper>
    )
};
